export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/account-settings/resources/mounted.js